module.exports = __webpack_public_path__ + "img/directorys.d5eb745e.svg";